<script>
  import Root from '@components/Templates/Root';
  import { nestedInitial } from '@ducks/nested';
  import { bindAction, store } from '@store';
  export let path;
</script>

<script context="module">
  export async function preload(ctx) {
    const url =!store.isServer ? window.location.pathname : false
    const checkPath = path => path !== '/null' && path !== '/undefined' && path !== '/favicon.ico'
    if (ctx && checkPath(ctx.path)) {
      bindAction(nestedInitial)({ ctx, url, error: this.error });
    }
    if (this.store.isServer) {
      await this.store.completeSaga();
    }
  };
</script>
<Root {path} />
